module.exports = __webpack_public_path__ + "static/media/pentagono.bacefcf4.svg";